import { Loader2 } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconLoader2(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Loader2 />
    </IconWrapper>
  );
}
